"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChartData = void 0;
var _types = require("../types");
var _datasetUtils = require("./datasetUtils");
var _gradients = require("./gradients");
var _constants = require("./constants");
var _getCustoms = require("./getCustoms");
const getChartData = params => {
  const {
    props,
    ctx
  } = params;
  const c = (0, _getCustoms.getCustoms)(props);
  const gradientEstimatedPrice = (0, _gradients.getGradientEstimatedPrice)(ctx);
  const gradientOfferPrice = (0, _gradients.getGradientOfferPrice)(ctx);
  const houseTrendGradient = (0, _gradients.getHouseTrendGradient)(ctx);
  const marketTrendGradient = (0, _gradients.getMarketTrendGradient)(ctx);
  const {
    data: {
      offerPrice,
      estimatedPrice,
      marketTrend,
      houseTrend,
      supplyTrend,
      demandTrend
    },
    datasetsXRange
  } = (0, _datasetUtils.prepareSrcData)(props, {
    convertToUTC: props.convertToUTC
  });
  const datasets = [];
  if (props.type === _types.EChartTypes.Default) {
    if ((0, _datasetUtils.isData)(offerPrice)) {
      datasets.push({
        data: offerPrice,
        backgroundColor: gradientOfferPrice,
        pointBackgroundColor: _constants.RED_COLOR,
        pointBorderColor: c.BG_COLOR,
        borderColor: _constants.RED_COLOR,
        fill: 'origin',
        order: 1,
        id: _types.EChartDatasetId.OfferPrice
      });
    }
    if ((0, _datasetUtils.isData)(estimatedPrice)) {
      datasets.push({
        data: estimatedPrice,
        backgroundColor: gradientEstimatedPrice,
        pointBackgroundColor: _constants.BLUE_COLOR,
        pointBorderColor: c.BG_COLOR,
        fill: true,
        order: datasets.length + 1,
        id: _types.EChartDatasetId.EstimatedPrice,
        segment: {
          borderColor
        }
      });
    }
  } else if (props.type === _types.EChartTypes.Trends) {
    if ((0, _datasetUtils.isData)(houseTrend)) {
      datasets.push({
        data: houseTrend,
        backgroundColor: houseTrendGradient,
        pointBackgroundColor: _constants.MAGENTA_COLOR,
        pointBorderColor: c.BG_COLOR,
        borderColor: _constants.MAGENTA_COLOR,
        fill: true,
        order: datasets.length + 1,
        id: _types.EChartDatasetId.HouseTrend
      });
    }
    if ((0, _datasetUtils.isData)(marketTrend)) {
      datasets.push({
        data: marketTrend,
        backgroundColor: marketTrendGradient,
        pointBackgroundColor: _constants.BLUE_COLOR,
        pointBorderColor: c.BG_COLOR,
        borderColor: _constants.BLUE_COLOR,
        fill: 'origin',
        order: 1,
        id: _types.EChartDatasetId.MarketTrend
      });
    }
  } else if (props.type === _types.EChartTypes.SupplyDemand) {
    if ((0, _datasetUtils.isData)(demandTrend)) {
      datasets.push({
        data: demandTrend,
        backgroundColor: houseTrendGradient,
        pointBackgroundColor: 'transparent',
        pointBorderColor: 'transparent',
        borderColor: _constants.MAGENTA_COLOR,
        fill: 'origin',
        order: 1,
        id: _types.EChartDatasetId.DemandTrend
      });
    }
    if ((0, _datasetUtils.isData)(supplyTrend)) {
      datasets.push({
        data: supplyTrend,
        backgroundColor: marketTrendGradient,
        pointBackgroundColor: 'transparent',
        pointBorderColor: 'transparent',
        borderColor: _constants.BLUE_COLOR,
        fill: true,
        order: datasets.length + 1,
        id: _types.EChartDatasetId.SupplyTrend
      });
    }
  }
  return {
    datasets,
    datasetsXRange
  };
};
exports.getChartData = getChartData;
function borderColor(ctx) {
  const {
    estimationPricePoint
  } = (0, _datasetUtils.getLinesBeginPoints)(ctx);
  if (estimationPricePoint && (ctx.p1.parsed.x === estimationPricePoint.date || ctx.p1.parsed.x < estimationPricePoint.date)) {
    return 'rgba(4, 104, 255, 0.1)';
  }
  return _constants.BLUE_COLOR;
}